import { useEffect, useState } from 'react'
import { deploytime } from '@/lib/util'
import { RootState } from '@/app/store'
import { useSelector } from 'react-redux'

const useDeployTimeStamp = () => {
  const [DeployState, setDeployState] = useState(undefined)
  const datadataCampain = useSelector(
    (campainState: RootState) => campainState.campain.campaign
  )

  const VisibilityEvent = () => {
    let hidden: string
    let visibilityChange: string

    if (typeof document.hidden !== 'undefined') {
      hidden = 'hidden'
      visibilityChange = 'visibilitychange'
      //@ts-ignore
    } else if (typeof document.mozHidden !== 'undefined') {
      hidden = 'mozHidden'
      visibilityChange = 'mozvisibilitychange'
      //@ts-ignore
    } else if (typeof document.msHidden !== 'undefined') {
      hidden = 'msHidden'
      visibilityChange = 'msvisibilitychange'
      //@ts-ignore
    } else if (typeof document.webkitHidden !== 'undefined') {
      hidden = 'webkitHidden'
      visibilityChange = 'webkitvisibilitychange'
    }

    document.addEventListener(visibilityChange, () => {
      if (document.visibilityState === 'visible') {
        // fetchFunc()
      }
    })
  }

  useEffect(() => {
    if (datadataCampain) {
      if (datadataCampain.campaignEndAt !== '') {
        setDeployState(datadataCampain)
      }
    }
  }, [datadataCampain])

  useEffect(() => {
    VisibilityEvent()
  }, [])

  useEffect(() => {
    if (DeployState !== undefined) {
      const DEPLOY_TIMESTAMP_OLD = localStorage.getItem(
        `${process.env.NEXT_PUBLIC_SERVICE_NAME}_DEPLOY_TIMESTAMP`
      )

      if (DEPLOY_TIMESTAMP_OLD === null) {
        location.reload()
        localStorage.setItem(
          `${process.env.NEXT_PUBLIC_SERVICE_NAME}_DEPLOY_TIMESTAMP`,
          deploytime(DeployState.timestamp)
        )
        return
      }

      if (DEPLOY_TIMESTAMP_OLD !== deploytime(DeployState.timestamp)) {
        localStorage.setItem(
          `${process.env.NEXT_PUBLIC_SERVICE_NAME}_DEPLOY_TIMESTAMP`,
          deploytime(DeployState.timestamp)
        )
        location.reload()
      }
    }
  }, [DeployState])
}

export default useDeployTimeStamp
